import { findIndex, cloneDeep } from "lodash";
import {
  TOGGGLE_LID_MC,
  OPEN_MODAL_MC,
  CLOSE_MODAL_MC,
  SET_MODAL_VIEW_MC,
  SET_RPM_MC,
  SET_TIMER_MC,
  ON_DROP_SLOT_MC,
  ON_RUN_CENTRIFUGE_MC,
  ON_STOP_CENTRIFUGE_MC,
  ANIMATION_PLAYBACK_COMPLETE_MC,
  ON_DROP_CENTRIFUGE_MC,
  REMOVE_SLOT_ITEMS_MC,
} from "../../Redux.constants";

const templateState = {
  id: -1,
  type: null,
  modalOpen: false,
  lidOpen: false,
  modalView: 'TOP_VIEW',
  balanced: false,
  running: false,
  pulsing: false,
  completed: false,
  topViewData: {},
  frontViewData: {
    settings: {
      rpmValue: 1300,
      timerValue: new Date(0, 0, 0),
    },
  },

  slots: [
    {
      id: 1,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 2,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 3,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 4,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 5,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 6,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 7,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 8,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 9,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 10,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 11,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    },
    {
      id: 12,
      solutionId: null,
      rotorId: null,
      tubeType: "",
      solution: false,
      rotor: false,
      defaultProps: null,
    }
  ],

  isOpen: true,
};

export function MicrocentrifugeReducer(
  state = { microcentrifuge: [] },
  action
) {
  let currentMicrocentrifuge;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_MICROCENTRIFUGE" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("microcentrifuge")
      ) {
        currentMicrocentrifuge =
          state.protocolSection.scene.apparatus.microcentrifuge[
          findIndex(state.protocolSection.scene.apparatus.microcentrifuge, {
            id: action.payload.id,
          })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_MICROCENTRIFUGE":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("microcentrifuge")) {
        protocolSection.scene.apparatus.microcentrifuge = [
          ...protocolSection.scene.apparatus.microcentrifuge,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.microcentrifuge = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };

    case TOGGGLE_LID_MC:
      currentMicrocentrifuge.lidOpen = !currentMicrocentrifuge.lidOpen
      return updateState();

    case OPEN_MODAL_MC:
      currentMicrocentrifuge.modalOpen = true
      return updateState();

    case CLOSE_MODAL_MC:
      currentMicrocentrifuge.modalOpen = false
      return updateState();

    case SET_MODAL_VIEW_MC:
      currentMicrocentrifuge.modalView = action.payload.data
      return updateState();

    case SET_RPM_MC:
      const RPM = { MAX: 50000, MIN: 1000 };
      const rpmValue = action.payload.data
      if (rpmValue > RPM.MAX) {
        currentMicrocentrifuge.frontViewData = {
          ...currentMicrocentrifuge.frontViewData,
          settings: {
            ...currentMicrocentrifuge.frontViewData.settings,
            rpmValue: RPM.MAX,
          },
        }
      }

      else if (rpmValue < RPM.MIN) {
        currentMicrocentrifuge.frontViewData = {
          ...currentMicrocentrifuge.frontViewData,
          settings: {
            ...currentMicrocentrifuge.frontViewData.settings,
            rpmValue: RPM.MIN,
          },
        }
      }
      else {
        currentMicrocentrifuge.frontViewData = {
          ...currentMicrocentrifuge.frontViewData,
          settings: {
            ...currentMicrocentrifuge.frontViewData.settings,
            rpmValue,
          },
        }
      }
      return updateState();

    case SET_TIMER_MC:
      currentMicrocentrifuge.frontViewData = {
        ...currentMicrocentrifuge.frontViewData,
        settings: {
          ...currentMicrocentrifuge.frontViewData.settings,
          timerValue: new Date(action.payload.data),
        },
      }
      return updateState();

    case ON_DROP_SLOT_MC:
      const droppedLocationSlot = currentMicrocentrifuge.slots.find(
        (slot) => slot.id === action.payload.data.locationId
      );
      const droppedSlot = currentMicrocentrifuge.slots.find((slot) => slot.id === action.payload.data.droppedId);
      const updateSlots = (slot) => {
        if (slot.id === droppedLocationSlot.id)
          return {
            ...slot,
            rotor: droppedSlot.rotor,
            solution: droppedSlot.solution,
            solutionId: droppedSlot.solutionId,
            defaultProps: droppedSlot.defaultProps,
            rotorId: droppedSlot.rotorId,
          };
        else if (slot.id === droppedSlot.id)
          return {
            ...slot,
            rotor: droppedLocationSlot.rotor,
            solution: droppedLocationSlot.solution,
            solutionId: droppedLocationSlot.solutionId,
            defaultProps: droppedLocationSlot.defaultProps,
            rotorId: droppedLocationSlot.rotorId,
          };
        else return slot;
      };

      const newSlotsArrangement = currentMicrocentrifuge.slots.map(updateSlots);
      const balancedValued = centrifugeBalanced(newSlotsArrangement)

      currentMicrocentrifuge.slots = cloneDeep(newSlotsArrangement)
      currentMicrocentrifuge.balanced = balancedValued
      return updateState();


    case ON_RUN_CENTRIFUGE_MC:
      const PULSE_ACTION = 'PULSE';
      if (action.payload === PULSE_ACTION){
        currentMicrocentrifuge.running = true
        currentMicrocentrifuge.pulsing = true
      }else{
        currentMicrocentrifuge.running = true
      }
      return updateState();

    case ON_STOP_CENTRIFUGE_MC:
      currentMicrocentrifuge.running = false
      currentMicrocentrifuge.pulsing = false
      return updateState();

    case ANIMATION_PLAYBACK_COMPLETE_MC:
      currentMicrocentrifuge.running = false
      currentMicrocentrifuge.completed = true
      currentMicrocentrifuge.frontViewData = {
        ...currentMicrocentrifuge.frontViewData,
        timerValue: new Date(0, 0, 0),
      }

      // TODO: Add pulse checks
      //if(currentMicrocentrifuge.pulsing){
        // Set mix behaviour
        currentMicrocentrifuge.slots.map((slot)=>{
          if(slot.solutionId){
            let solution =
              state.protocolSection.scene.apparatus.solutions[
              findIndex(state.protocolSection.scene.apparatus.solutions, {
                id: slot.solutionId,
              })
              ];

            solution.mixed = true;
            protocolSection.scene.apparatus.solutions[findIndex(state.solutiona, { id: slot.solutionId })] = solution;
          }
        })
      //}
      return updateState();

    case ON_DROP_CENTRIFUGE_MC:
      onItemDropCentrifuge(currentMicrocentrifuge, action.payload);
      const balancedValue = centrifugeBalanced(currentMicrocentrifuge.slots)
      currentMicrocentrifuge.balanced = balancedValue
      return updateState();

    case REMOVE_SLOT_ITEMS_MC:
      if(action.payload.data === 'rotor'){
        const emptySlots = currentMicrocentrifuge.slots;
        for(let zlot of emptySlots){
          zlot.solution = false;
          zlot.solutionId = null
          zlot.rotor = false
        }
        currentMicrocentrifuge.slots = cloneDeep(emptySlots)
        protocolSection.scene.apparatus.microcentrifuge[findIndex(state.microcentrifuge, { id: action.payload.id })] = currentMicrocentrifuge;
        return { ...state, ...{ protocolSection: protocolSection } };
      }else{

      const emptySlots = currentMicrocentrifuge.slots;
      for(let zlot of emptySlots){
        zlot.solution = false;
        zlot.solutionId = null
      }
      currentMicrocentrifuge.slots = cloneDeep(emptySlots);
      protocolSection.scene.apparatus.microcentrifuge[findIndex(state.microcentrifuge, { id: action.payload.id })] = currentMicrocentrifuge;
      return { ...state, ...{ protocolSection: protocolSection } };
    }

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null) {
        protocolSection.scene.apparatus.microcentrifuge =
          action.payload.lastState.scene.apparatus.microcentrifuge;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
  function onItemDropCentrifuge(currentMicrocentrifuge, payload) {
    const newSlotArrangement = getNewSlots(currentMicrocentrifuge.slots, payload.type, payload.itemId, payload.defaultProps);
    currentMicrocentrifuge = {
      ...currentMicrocentrifuge,
      completed: false,
      slots: cloneDeep(newSlotArrangement),

    };
  };

  function getNewSlots(slots, type, itemId, defaultProps) {
    if (type === 'NON_PCR') {
      return addNewItem(
        slots,
        { solution: true, solutionId: itemId, defaultProps },
        (slotData) => slotData.rotor === false && slotData.solution === false
      );
    } else if (type === 'PCR') {
      return addNewItem(
        slots,
        { solution: true, solutionId: itemId, defaultProps },
        (slotData) => slotData.rotor === true && slotData.solution === false
      );
    } else if (type === 'ROTOR') {
      return addNewItem(
        slots,
        { rotor: true, rotorId: itemId },
        (slotData) => slotData.rotor === false && slotData.solution === false
      );
    }

  };

  function addNewItem(slots, newSlotData, slotEmptyCheck) {
    const VISIBLE_POSITIONS = [11, 12, 1, 2, 3];

    const emptySpotIdInVisible = VISIBLE_POSITIONS.find((slotId) => {
      return slots.find(
        (slotData) => slotData.id === slotId && slotEmptyCheck(slotData)
      );
    });

    if (emptySpotIdInVisible) {
      for (let slotPostion = 0; slotPostion < slots.length; slotPostion++) {
        let slot = slots[slotPostion]
        if (slot.id === emptySpotIdInVisible) {
          slots[slotPostion] = { ...slot, ...newSlotData }
          break
        }
      }
      return slots
    } else {
      for (let slotPostion = 0; slotPostion < slots.length; slotPostion++) {
        let slot = slots[slotPostion]
        if (slotEmptyCheck(slot)) {
          slots[slotPostion] = { ...slot, ...newSlotData }
          break
        }
      }
      return slots
    }
  };

  function centrifugeBalanced(slots) {
    let numberOfSlots = slots.length;
    let internalAngle = 360 / numberOfSlots; // Internal angle of a single slot

    let radius = 1; // Length from center (0,0) to a single slot (1,0)
    let balanceX = 0;
    let balanceY = 0;

    slots.map((slot, i) => {
      if (slot.solution) {
        // Calculate the coordinate value for this slot (Math.sin / Math.cos require radians and not degrees)
        let oppositeSide =
          Math.sin(internalAngle * (i + 1) * (Math.PI / 180)) * radius;
        let adjacentSide =
          Math.cos(internalAngle * (i + 1) * (Math.PI / 180)) * radius;

        // Round the values to avoid floating point errors
        balanceX += +oppositeSide.toFixed(3);
        balanceY += +adjacentSide.toFixed(3);
      }
    });

    return +balanceX.toFixed(3) === 0 && +balanceY.toFixed(3) === 0;
  };

  function updateState() {
    currentMicrocentrifuge.slots = cloneDeep(currentMicrocentrifuge.slots)
    protocolSection.scene.apparatus.microcentrifuge[findIndex(state.microcentrifuge, { id: action.payload.id })] = currentMicrocentrifuge;
    return { ...state, ...{ protocolSection: protocolSection } };
  }
}
